import React, { Component } from 'react';
// import { cdnDomain } from '../utilities/config';
import { MotorService } from '../services/motorService';
// const OMLogo = `${cdnDomain}/static/images/omi-logo.png`

class Footer extends Component {
  constructor(props){
    super(props)
    this.state = {
      underwriting_message: ''
    }
  }

  componentDidMount = async ()=>{
    await this.getConfig()
  }


  getConfig = async () => {
    try {
      const response = await MotorService.getConfig();

      if (response && response.success && response.data) {
        this.setState({ underwriting_message: response.data.underwriting_message });
      } else {
        this.setState({ underwriting_message: '' });
      }
    } catch (error) {
      console.error('Error fetching config:', error);
    }
  };

  render = () => {
    const {underwriting_message} = this.state
    return(
      <div className="footer footer--mobile grid-x">
        <div className="footer__underwriter-content cell large-12">
          <div className="footer__underwriter-content--is-left">
            {/* <img src={OMLogo} className="footer__underwriter-content__logo" /> */}
            <p className="home-contents-main-container-footer" >{underwriting_message} <a style={{ textDecoration: 'inherit', color: 'inherit', textDecorationLine: 'underline'  }} href='https://www.pineapple.co.za/terms-and-conditions/' target='_blank'>T&Cs</a> apply.</p>
          </div>
        </div>
        <div className="footer__content grid-x">
          <div className="footer__content--is-left cell small-12 large-6">
            <ul className="footer__list">
              <li className="footer__list-item footer__list-item--is-border-right">
                <a className="footer__link" href={'https://www.pineapple.co.za'} target="_blank">
                  How it works
                </a>
              </li>
              <li className="footer__list-item footer__list-item--is-border-right">
                <a className="footer__link" href={'https://www.pineapple.co.za/terms-and-conditions/'} target="_blank">
                  Terms and Conditions
                </a>
              </li>
              <li className="footer__list-item">
                <a className="footer__link" href={'https://www.getpineapple.info/my-ride'} target="_blank">
                  Policy Wording
                </a>
              </li>
            </ul>
          </div>
          <div className="footer__content--is-right cell small-12 large-6">
            <p className="footer__text"> Pineapple<sup>TM</sup> 2020. All Rights Reserved. FAIS licence no. 48650 </p> 
          </div>
        </div>
      </div>
    )
  }
}

export default Footer